import { apiClient } from '~/api/client';
import { LoanTransactionsMeta } from '~/sections/companies/profile/performance/types';

type IndexParams = {
  period: Period;
  license: string;
};

type IndexResponse = {
  meta: LoanTransactionsMeta;
};

export const index = async (allParams: IndexParams) => {
  const { license, ...params } = allParams;
  return apiClient.get<IndexResponse>(`/companies/${license}/performance`, { params });
};
